
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.5 7.313V2H5.687a.935.935 0 00-.937.938v18.125c0 .519.418.937.938.937h13.125c.519 0 .937-.418.937-.938V8.25h-5.313a.94.94 0 01-.937-.938zm2.986 8.256l-3.766 3.738a.666.666 0 01-.94 0l-3.766-3.738a.625.625 0 01.44-1.069H11v-3.125c0-.345.28-.625.625-.625h1.25c.345 0 .625.28.625.625V14.5h2.546c.558 0 .836.675.44 1.069zm2.99-9.467l-3.824-3.829A.937.937 0 0014.988 2h-.238v5h5v-.238a.935.935 0 00-.273-.66z","fill":"#282E3E"}})])
          )
        }
      }
    